import { useEffect } from 'react';

import type { MarkerProps } from './ConfidenceMap';

export type GoogleMapInstance = {
  getBounds: () => {
    toJSON: () => { north: number; south: number; east: number; west: number };
  } | null;
  panTo: (center: { lat: number; lng: number }) => void;
};

type Props = {
  mapInstance: GoogleMapInstance | null;
  markers: MarkerProps[];
  selectedMarkerId: string | undefined;
};

const isOutsideBounds = (
  lat: number,
  lng: number,
  bounds: { north: number; south: number; east: number; west: number },
) => lat < bounds.south || lat > bounds.north || lng < bounds.west || lng > bounds.east;

export const usePanToSelected = ({ mapInstance, markers, selectedMarkerId }: Props) => {
  useEffect(() => {
    if (!selectedMarkerId || !mapInstance) return;

    const marker = markers.find((m) => m.destinationAirportCode === selectedMarkerId);
    if (!marker) return;

    const bounds = mapInstance.getBounds?.()?.toJSON?.();
    if (!bounds) return;

    const { latitude: lat, longitude: lng } = marker.coordinates;
    if (isOutsideBounds(lat, lng, bounds)) {
      mapInstance.panTo({ lat, lng });
    }
  }, [selectedMarkerId, mapInstance, markers]);
};
